export const ResultInitialStatus = 'initial' as const;
// Radar Status Code Path
export const RADAR_HOTELS_STATUS_CODE_PATH = 'body.accommodations.context.status';
export const RADAR_RAIL_STATUS_CODE_PATH = 'body.rail.context.status';

export const RADAR_RAIL_STATUS_SESSION_ID = 'body.rail.context.sessionId';
export const RADAR_FLIGHTS_RESULTS = 'body.itineraries.results';

// For unfocused searches
export const UNFOCUSED_SESSION_ID = 'UNFOCUSED_SESSION_ID';

export const ResultStatus = {
  INCOMPLETE: 'incomplete',
  INCOMPLETE_NOT_MODIFIED: 'incomplete_not_modified',
  COMPLETE: 'complete',
  COMPLETE_NOT_MODIFIED: 'complete_not_modified',
  FAILURE: 'failure',
} as const;

export const RADAR_STATUS_CODE_PATH = 'body.context.status';
export const RADAR_FLIGHTS_STATUS_CODE_PATH = 'body.itineraries.context.status';

export const RADAR_MAX_DESTINATIONS = 200;
